<template>
	<transition name="new-side-menu">
		<aside v-if="open" class="new-side-menu" @click.self="$emit('close')">
			<section class="new-side-menu__panel">
				<button class="new-side-menu__close" type="button" @click="$emit('close')" aria-label="Fechar menu">
					<span></span>
					<span></span>
				</button>

				<nav class="new-side-menu__nav">
					<router-link to="/company-profile" @click.native="$emit('close')">{{translation.companyProfile}}</router-link>
					<router-link to="/calendar" @click.native="$emit('close')">{{translation.calendar}}</router-link>
					<router-link to="/accommodation" @click.native="$emit('close')">{{translation.accommodation}}</router-link>
					<router-link to="/flight-bookings" @click.native="$emit('close')">{{translation.flightBookings}}</router-link>
					<router-link to="/transportation" @click.native="$emit('close')">{{translation.transportation}}</router-link>
					<router-link to="/pre-post-tours" @click.native="$emit('close')">{{translation.preAndPostTours}}</router-link>
					<a :href="localTours">{{translation.localTours}}</a>
					<a :href="resume">{{translation.resume}}</a>
					<router-link to="/clients-area" @click.native="$emit('close')">{{translation.clientsArea}}</router-link>
				</nav>
			</section>
		</aside>
	</transition>
</template>

<script>
import { translate } from '../../../assets/translations';

export default {
	props: {
		open: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			localTours: 'https://eventos.blumar.com.br/local-tours',
			resume: 'https://eventos.blumar.com.br/resume',
		};
	},
	computed: {
		translation() {
			return translate(this.$store.state.language).navbar;
		},
	},
	watch: {
		open(value) {
			document.body.style.overflow = value ? 'hidden' : '';
		},
	},
	methods: {
		closeOnEscape(event) {
			if (event.key === 'Escape') this.$emit('close');
		},
	},
	mounted() {
		document.addEventListener('keyup', this.closeOnEscape);
	},
	beforeDestroy() {
		document.body.style.overflow = '';
		document.removeEventListener('keyup', this.closeOnEscape);
	},
};
</script>

<style scoped lang="scss">
.new-side-menu {
	position: fixed;
	inset: 0;
	z-index: 100;
	background: rgba(5, 27, 39, .04);
}

.new-side-menu__panel {
	position: relative;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	width: 52vw;
	min-width: 0;
	max-width: 900px;
	height: 100%;
	overflow: hidden;
	margin-left: auto;
	padding: 2vw 5vw 3vw;
	background: #78b2c9;
	box-shadow: -16px 0 40px rgba(4, 30, 45, .18);
}

.new-side-menu__close {
	position: absolute;
	top: 1.4vw;
	right: 5.36%;
	z-index: 1;
	width: 6.47%;
	aspect-ratio: 70 / 63.88;
	padding: 0;
	border: 0;
	background: #5da3bd;
	cursor: pointer;
	transition: background-color .2s ease;
}

.new-side-menu__close:hover,
.new-side-menu__close:focus-visible {
	background: #4c94af;
}

.new-side-menu__close:focus-visible {
	outline: 2px solid #ffffff;
	outline-offset: 2px;
}

.new-side-menu__close span {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 81.3%;
	height: .25rem;
	background: #ffffff;
	transform-origin: center;
}

.new-side-menu__close span:first-child {
	transform: translate(-50%, -50%) rotate(45deg);
}

.new-side-menu__close span:last-child {
	transform: translate(-50%, -50%) rotate(-45deg);
}

.new-side-menu__nav {
	display: flex;
	flex: 1 1 auto;
	flex-direction: column;
	align-items: flex-start;
	gap: 2vw;
	min-height: 0;
	overflow-y: auto;
	overscroll-behavior: contain;
	padding-right: 12px;
	-webkit-overflow-scrolling: touch;
	scrollbar-color: rgba(255, 255, 255, .75) rgba(255, 255, 255, .15);
	scrollbar-width: thin;
}

.new-side-menu__nav::-webkit-scrollbar {
	width: 6px;
}

.new-side-menu__nav::-webkit-scrollbar-track {
	background: rgba(255, 255, 255, .15);
	border-radius: 3px;
}

.new-side-menu__nav::-webkit-scrollbar-thumb {
	background: rgba(255, 255, 255, .75);
	border-radius: 3px;
}

.new-side-menu__nav a {
	position: relative;
	display: inline-block;
	padding-top: .7vw;
	color: #ffffff;
	font-size: 1.75vw;
	font-weight: 400;
	line-height: 1.2;
	text-transform: uppercase;
	text-decoration: none;
}

.new-side-menu__nav a::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 50px;
	height: 2px;
	background: #E89127;
	opacity: 0;
	transform: translate(-12px, 10px) scaleX(.18);
	transform-origin: left center;
	transition:
		opacity .2s ease,
		transform .28s cubic-bezier(.2, .8, .2, 1);
}

.new-side-menu__nav a:hover,
.new-side-menu__nav a:focus-visible {
	color: #ffffff;
}

.new-side-menu__nav a:hover::before,
.new-side-menu__nav a:focus-visible::before {
	opacity: 1;
	transform: translate(0, 0) scaleX(1);
}

.new-side-menu-enter-active,
.new-side-menu-leave-active {
	transition: background-color .34s ease;
}

.new-side-menu-enter-active .new-side-menu__panel,
.new-side-menu-leave-active .new-side-menu__panel {
	transition: transform .34s ease;
}

.new-side-menu-enter,
.new-side-menu-leave-to {
	background: rgba(5, 27, 39, 0);
}

.new-side-menu-enter .new-side-menu__panel,
.new-side-menu-leave-to .new-side-menu__panel {
	transform: translateX(100%);
}

@media (min-width: 1728px) {
	.new-side-menu__panel {
		padding-top: 104px;
		padding-right: 86px;
		padding-bottom: 52px;
		padding-left: 86px;
	}

	.new-side-menu__nav {
		gap: 35px;
	}

	.new-side-menu__nav a {
		padding-top: 12px;
		font-size: 30px;
	}
}

@media (max-width: 720px) {
	.new-side-menu__panel {
		width: 100vw;
		min-width: 0;
		padding: 102px 46px 42px;
	}

	.new-side-menu__close {
		top: 1.125rem;
		right: 1.625rem;
		width: 3.5rem;
	}

	.new-side-menu__nav {
		gap: 28px;
	}

	.new-side-menu__nav a {
		font-size: 25px;
	}
}

@media (max-width: 420px) {
	.new-side-menu__panel {
		padding-left: 32px;
		padding-right: 32px;
	}

	.new-side-menu__nav a {
		font-size: 22px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/header/Navbar.vue